import aip from "@/assets/crystals/aip.webp";
import forge from "@/assets/crystals/forge.webp";
import axis from "@/assets/crystals/axis.webp";
import pulse from "@/assets/crystals/pulse.webp";
import core from "@/assets/crystals/core.webp";

export type CrystalVariant = "aip" | "forge" | "axis" | "pulse" | "core";

export const CRYSTAL_IMAGES: Record<CrystalVariant, string> = {
  aip,
  forge,
  axis,
  pulse,
  core,
};

interface Props {
  variant: CrystalVariant;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_PX: Record<NonNullable<Props["size"]>, number> = {
  sm: 64,
  md: 96,
  lg: 200,
};

export const SolutionCrystal = ({ variant, size = "md", className }: Props) => {
  const px = SIZE_PX[size];
  const src = CRYSTAL_IMAGES[variant];

  return (
    <div
      className={className}
      style={{ width: px, height: px }}
      aria-hidden="true"
    >
      <img
        src={src}
        alt=""
        loading="eager"
        decoding="async"
        fetchPriority="high"
        width={px}
        height={px}
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export default SolutionCrystal;
